export enum TelemetrySchemaType {
  Boolean = "Boolean",
  Date = "Date",
  DateTime = "DateTime",
  Double = "Double",
  Duration = "Duration",
  Float = "Float",
  Integer = "Integer",
  Long = "Long",
  String = "String",
  Time = "Time",
  Point = "Point",
  Enum = "Enum"
}
